module.exports = __webpack_public_path__ + "static/media/web2.264ecf22.png";